module.exports = __webpack_public_path__ + "f7b5a5d2e54cc31459f4933c7f3e9214.png";